import Helmet from "react-helmet";
import config from "../../../../config";

export const OneTrustScripts = () => {
  const {domainScript} = config.oneTrust || {};

  if (!domainScript) {
    return null;
  }

  return (
    <Helmet>
      <script
        type="text/javascript"
        src={`https://cdn.cookielaw.org/consent/${domainScript}/OtAutoBlock.js`}
      />

      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={domainScript}
      />
    </Helmet>
  );
};
